// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "wp-content/themes/betano-blog/js/" + chunkId + "." + {"22":"afa3b896","48":"a08132b8","98":"4598942e","181":"90c63886","317":"c8d434b1"}[chunkId] + ".js";
};